import ViewSourceEvent from 'matrix-react-sdk/lib/components/views/messages/ViewSourceEvent'
import StateEvent from './StateEvent'

// Usefull when your configuring new groove events for display
const DEBUG = false
const eventTypeToComponent = {
  'g.state': StateEvent,
  'g.assign': StateEvent,
}

export default function EventRouter(props) {
  const { mxEvent } = props
  const type = mxEvent.getType()
  const Component = eventTypeToComponent[type]

  if (Component) return <Component {...props} />
  if (DEBUG) return <ViewSourceEvent {...props} />
  return null
}
